<template>
  <div>
    <table class="mt-4 w-full">
      <tbody>
        <tr v-for="row in rows" :key="row.name">
          <td class="py-1">{{ row.name }}</td>
          <td class="py-1 text-right text-[15px]">
            <template v-if="!row?.price || row.price.withTax === 0">
              {{ $i18n.t('pdp.glasses.inclusive') }}
            </template>
            <template v-else>
              <ProductPriceFtPrismaDesign
                :price="row.price"
                type="whisper"
                align="right"
              />
            </template>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="border-t border-t-gray-350 pt-2 font-medium">
            {{ totalRow.name }}
          </td>
          <td class="border-t border-t-gray-350 py-2 text-right text-[15px]">
            <ProductPriceFtPrismaDesign :price="totalRow.price" align="right" />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script setup lang="ts">
import {
  type Product,
  getFirstAttributeValue,
  type Variant,
} from '@scayle/storefront-nuxt'
import { useProductPrice } from '~/composables/useProductPrice'
import useRxFreeServiceProduct from '~/composables/pdp/useRxFreeServiceProduct'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  variant: {
    type: Object as PropType<Variant>,
    required: true,
  },
})

const $i18n = useI18n()
const { getCheapestLensForFrame, getFrame, getCombinedProductPrice } =
  await useProductPrice()
const freeService = await useRxFreeServiceProduct()

/* Frame price */
const { product: frame, price: framePrice } = getFrame(
  props.product,
  props.variant,
)
const frameRow = {
  name: getFirstAttributeValue(frame?.attributes, 'name')?.label ?? '',
  price: framePrice,
}

/* Cheapest lens for this frame */
const { product: lensProduct, price: lensPrice } = getCheapestLensForFrame(
  props.product,
)
const lensRow = {
  name: getLensName(lensProduct),
  price: lensPrice,
}

/* Get free service for store */
const freeServiceRow = {
  name:
    (freeService.value &&
      getFirstAttributeValue(freeService.value.attributes, 'name')?.label) ??
    '',
  price: null,
}

const totalRow = computed(() => ({
  name: $i18n.t('rx.total'),
  price: getCombinedProductPrice(props.product, props.variant),
}))

const rows = computed(() => [frameRow, lensRow, freeServiceRow])
</script>

<style scoped>
tbody tr:last-child td {
  padding-bottom: 0.75rem;
}
</style>
